import * as React from "react"
import { Navigate } from "react-router-dom"

import { USER_ROLE } from "@constants"
import AppLayout from "Layout"
import MappersStatsPage from "./index"


export const MappersStatsRoutes = {
    path: "/mappers-stats",
    title: "Mappers Stats",
    icon: 'chart-user',
    iconWeight: 'light',
    element: <AppLayout />,
    description: 'Statistics dashboard for all mappers',
    access: USER_ROLE.ADMIN,
    children: [{
        element: <MappersStatsPage />, 
        index: true
    }]
}
